slideShowPresenter.controller('slideShowPresenterCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    'logService',
    '$timeout',
    'socketService',
    'attendeeService',
    'contentService',
    'pollingService',
    'questionService',
    'meetingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $window,
        logService,
        $timeout,
        socketService,
        attendeeService,
        contentService,
        pollingService,
        questionService,
        meetingService,
        localizationService
    ) {
        var self = this;
        const logger = logService.createLoggerWithSource('slideShowPresenterCtrl');

        self.curIndex = 0;
        self.lastIndex = 0;
        self.total = 0;
        self.attendantId = 0;
        self.idle = false;
        self.idleTimeout = null;
        self.isLoaded = false;
        self.currentTransition = '';
        self.recentlyEndedTransition = ''; //This helps add proper fade transitions to indicator arrows
        self.controlHovered = false;
        self.pageCountReceived = false;
        self.waitingForSlide = false;
        self.targetSlide = null;
        self.stop = stop;
        self.next = next;
        self.previous = previous;
        self.goToFirst = goToFirst;
        self.goToLast = goToLast;
        self.goToSpecificSlide = goToSpecificSlide;
        self.onGoToSlidePress = onGoToSlidePress;
        self.startIdleTimeout = startIdleTimeout;
        self.stopIdleTimeout = stopIdleTimeout;
        self.resetIdleTimeout = resetIdleTimeout;
        self.startControlHover = startControlHover;
        self.stopControlHover = stopControlHover;
        self.getSlideCountBtnTooltip = getSlideCountBtnTooltip;
        self.isVoting = isVoting;
        self.isInQandAMode = isInQandAMode;
        self.initFromContentService = initFromContentService;
        self.cleanup = cleanup;

        $scope.$on('slide-show-loaded', function (e, attendantId, playStatus) {
            if (meetingService.isWebinar()) {
                if (!attendeeService.getIsPresenter()) return;
            } else {
                if (attendantId !== self.attendantId) {
                    return;
                }
            }

            logger.log('Slideshow loaded');
            self.curIndex = 1;
            self.targetSlide = null;
            self.isLoaded = true;

            //Example of valid playStatus:
            //+OK 0/6 /path/to/slide.pdf
            //
            //Example of playStatus error:
            //-ERR Nothing is playing
            if (playStatus && playStatus.indexOf('+OK') !== -1) {
                logger.log('Slides playStatus received: ' + playStatus);

                self.initFromContentService();
            }

            digest();
        });

        $scope.$on('slide-show-unloaded', function (e) {
            logger.log('Slideshow unloaded');
            self.cleanup();
        });

        $scope.$on('new-slide-loaded', function (e, slide) {
            logger.log('Slideshow new-slide-loaded: ', slide, ' isWebinar: ', meetingService.isWebinar());

            if (meetingService.isWebinar()) {
                if (!attendeeService.getIsPresenter()) return;
            } else {
                if (slide.ownerID !== self.attendantId) {
                    return;
                }
            }

            logger.log('New slide loaded, self.currentTransition: ', self.currentTransition);
            self.curIndex = slide.index; //Add 1 to offset FS's zero-based numbering
            self.recentlyEndedTransition = self.currentTransition;
            self.currentTransition = '';
            self.waitingForSlide = false;

            digest();
        });

        $scope.$on('slideshow-pagecount', onSlideshowPagecount);
        $scope.$on('content-status', onContentInit);
        $scope.$on('node-reconnected', onNodeReconnected);
        $scope.$on('content-cleanup', cleanup);
        $scope.$on('slides-key-press', onSlidesKeyPress);
        $scope.contentService = contentService;

        init();

        ////////////////////////

        function init() {
            logger.debug('slideShowPresenter init');
            self.attendantId = attendeeService.getAttendantId();
            contentService.init();
        }

        function getSlideCountBtnTooltip() {
            if (self.pageCountReceived === true) {
                return localizationService.translate('SLIDESHOW.SLIDES_ARE_LOADED');
            } else {
                return localizationService.translate('SLIDESHOW.SLIDES_ARE_LOADING');
            }
        }

        function initFromContentService() {
            var contentObj = contentService.getCurrentContentObject();

            logger.log('initFromContentService contentObj', contentObj);

            if (contentObj.state != 'stopped' && contentObj.type == 'slides') {
                self.curIndex = contentObj.currentPage;
                self.targetSlide = null;
                self.lastIndex = contentObj.pageCount;

                if (
                    contentObj.ownerID == self.attendantId ||
                    (meetingService.isWebinar() && attendeeService.getIsPresenter())
                ) {
                    self.isLoaded = true;
                    self.pageCountReceived = true;
                }

                logger.log('initFromContentService: curIndex: ', self.curIndex, ' lastIndex: ', self.lastIndex);
            }
        }

        function stop() {
            contentService.stopCurrentContent();
        }

        function next() {
            logger.log('slideShowPresenterCtrl next');
            if (!self.isLoaded || self.waitingForSlide) {
                return;
            }

            //Can't go after last slide...
            if (self.lastIndex !== 0 && self.curIndex >= self.lastIndex) {
                self.recentlyEndedTransition = self.currentTransition;
                self.currentTransition = '';
                return;
            }

            logger.log('Next slide');
            self.recentlyEndedTransition = '';
            self.currentTransition = 'next';
            self.waitingForSlide = true;

            var msgObj = {
                message: 'go-to-slide',
                data: { slide: 'next' }
            };

            socketService.send(msgObj);
        }

        function previous() {
            logger.log('slideShowPresenterCtrl previous');
            if (!self.isLoaded || self.waitingForSlide) {
                return;
            }

            //Can't go before first slide
            if (self.curIndex <= 1) {
                self.recentlyEndedTransition = self.currentTransition;
                self.currentTransition = '';
                return;
            }

            logger.log('Previous slide');
            self.recentlyEndedTransition = '';
            self.currentTransition = 'previous';
            self.waitingForSlide = true;

            var msgObj = {
                message: 'go-to-slide',
                data: { slide: 'previous' }
            };

            socketService.send(msgObj);
        }

        function goToFirst() {
            logger.log('slideShowPresenterCtrl goToFirst');
            if (!self.isLoaded || self.waitingForSlide) {
                return;
            }
            //Can't go before first slide
            if (self.curIndex <= 1) {
                self.recentlyEndedTransition = self.currentTransition;
                self.currentTransition = '';
                return;
            }
            self.goToSpecificSlide(1);
        }

        function goToLast() {
            logger.log('slideShowPresenterCtrl goToLast');
            if (!self.isLoaded || self.waitingForSlide) {
                return;
            }

            //Can't go after last slide...
            if (self.lastIndex !== 0 && self.curIndex >= self.lastIndex) {
                self.recentlyEndedTransition = self.currentTransition;
                self.currentTransition = '';
                return;
            }

            self.goToSpecificSlide(self.lastIndex);
        }

        function goToSpecificSlide(targetSlide) {
            logger.log('Go to ' + targetSlide);
            self.recentlyEndedTransition = '';
            if (targetSlide < self.curIndex) {
                self.currentTransition = 'previous';
            } else {
                self.currentTransition = 'next';
            }
            self.waitingForSlide = true;

            var msgObj = {
                message: 'go-to-slide',
                data: { slideNum: targetSlide }
            };

            socketService.send(msgObj);
        }

        function onGoToSlidePress() {
            if (self.targetSlide === null || self.targetSlide === undefined) {
                self.targetSlide = null;
                return;
            }
            if (self.targetSlide > self.lastIndex) {
                self.targetSlide = self.lastIndex;
            } else if (self.targetSlide < 1) {
                self.targetSlide = 1;
            }

            self.goToSpecificSlide(self.targetSlide);
            self.targetSlide = null;
        }

        function resetIdleTimeout() {
            self.stopIdleTimeout();
            self.startIdleTimeout();
        }

        function stopIdleTimeout() {
            if (!self.isLoaded) {
                return;
            }

            //logger.log('Stopping idle timeout');

            if (self.idleTimeout) {
                $timeout.cancel(self.idleTimeout);
                self.idleTimeout = null;
            }
            self.idle = false;
        }

        function startIdleTimeout() {
            if (!self.isLoaded) {
                return;
            }

            self.idleTimeout = $timeout(function () {
                self.idle = true;
            }, 3000);
        }

        function startControlHover() {
            logger.log('Starting control hover');
            self.controlHovered = true;
            self.stopIdleTimeout();
        }

        function stopControlHover() {
            logger.log('Stopping control hover');
            self.controlHovered = false;
            self.startIdleTimeout();
        }

        function onSlideshowPagecount(e, data) {
            if (contentService.getContentOwner() === attendeeService.getAttendantId()) {
                var pageCount = parseInt(data.pageCount) || 0;

                logger.log('Slideshow Page Count Received:', pageCount);

                if (data.status === 'loaded') {
                    self.pageCountReceived = true;
                }
                self.lastIndex = pageCount;
                digest();
            }
        }

        function onContentInit(e, data) {
            // logger.log("onContentInit", data);
            if (data.type == 'slides') {
                self.initFromContentService();
                digest();
            }
        }

        function isVoting() {
            return pollingService.getIsVoting();
        }

        function isInQandAMode() {
            return questionService.getIsInQandAMode();
        }

        function onNodeReconnected() {
            self.waitingForSlide = false;
            self.recentlyEndedTransition = '';
            self.currentTransition = '';
            digest();
        }

        function cleanup() {
            self.curIndex = 0;
            self.targetSlide = null;
            self.lastIndex = 0;
            self.isLoaded = false;
            self.pageCountReceived = false;
            if (self.idleTimeout) {
                $timeout.cancel(self.idleTimeout);
                self.idleTimeout = null;
            }

            digest();
        }

        function onSlidesKeyPress(e, data) {
            if (!self.isLoaded) {
                return;
            }

            if (data === 'left') {
                self.previous();
            } else if (data === 'right') {
                self.next();
            } else if (data === 'stop') {
                self.stop();
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
